import { ClinicContactsCard } from '@/features/okdoc/components/ClinicContactsCard';
import { OkdocShell } from '@/features/okdoc/components/OkdocShell';
import {
  okdocBrandThemes,
  okdocDefaultTheme,
  okdocPatientPortals,
} from '@/features/okdoc/config';
import { AppointmentConfirmationLanding } from '@/features/okdoc/flows/appointment-confirmation/AppointmentConfirmationLanding';
import { FeedbackCollectionLanding } from '@/features/okdoc/flows/feedback-collection/FeedbackCollectionLanding';
import { RecommendationsLanding } from '@/features/okdoc/flows/recommendations/RecommendationsLanding';
import type { OkdocScenarioProfile } from '@/features/okdoc/types';
import {
  buildOkdocPreviewLanding,
  getOkdocShellCopy,
  resolvePublicScenarioProfile,
  type OkdocPreviewTenantClinic,
} from '@/features/okdoc/utils/scenarioProfile';

interface OkdocLandingDefinitionPreviewProps {
  flow: string;
  tenantName: string;
  tenantSlug?: string;
  scenarioProfile?: OkdocScenarioProfile;
  tenantClinic?: OkdocPreviewTenantClinic;
}

export function OkdocLandingDefinitionPreview({
  flow,
  tenantName,
  tenantSlug,
  scenarioProfile,
  tenantClinic,
}: OkdocLandingDefinitionPreviewProps) {
  const landing = buildOkdocPreviewLanding(flow, tenantName, tenantSlug, scenarioProfile, tenantClinic);
  const resolvedProfile = resolvePublicScenarioProfile(landing);
  const shellCopy = getOkdocShellCopy(flow, resolvedProfile);
  const theme = okdocBrandThemes[tenantSlug || ''] || okdocDefaultTheme;
  const patientPortal = tenantSlug ? okdocPatientPortals[tenantSlug] : undefined;
  const isFeedbackFlow = flow === 'feedback_collection';
  const isRecommendationsFlow = flow === 'recommendations';
	const isBirthdayOffer = landing.scenario_kind === 'birthday_offer';

  return (
    <div className="max-h-[70vh] overflow-auto rounded-2xl border border-neutral-200">
      <OkdocShell
        title={shellCopy.title}
			clinicName={isBirthdayOffer ? '' : landing.clinic_name || landing.tenant_name}
        theme={theme}
        subtitle={shellCopy.subtitle}
      >
        <div className="space-y-6">
          {isFeedbackFlow ? (
            <FeedbackCollectionLanding
              code="preview"
              landing={landing}
              theme={theme}
              submitStatus="idle"
              submitAction=""
              submitError=""
              onAction={() => undefined}
            />
          ) : isRecommendationsFlow ? (
            <RecommendationsLanding
              code="preview"
              landing={landing}
              theme={theme}
              onRedirect={() => undefined}
              patientPortal={patientPortal}
            />
          ) : (
            <AppointmentConfirmationLanding
              landing={landing}
              theme={theme}
              submitStatus="idle"
              submitAction=""
              submitError=""
              onAction={() => undefined}
            />
          )}

          <ClinicContactsCard landing={landing} accentClassName={theme.accent} />
        </div>
      </OkdocShell>
    </div>
  );
}
